module.exports = __webpack_public_path__ + "montserrat-semibolditalic-webfont.d63431fa8c23f7244d79.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-semibolditalic-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-semibolditalic-webfont.woff
// module chunks = styles